// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type CheckAskHolderQueryVariables = Types.Exact<{
  reservationId: Types.Scalars['Int']['input'];
  purchasedStayId: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type CheckAskHolderQueryResult = { __typename?: 'Query', checkAskHolder: boolean };

export const CheckAskHolderGql = gql`
    query CheckAskHolder($reservationId: Int!, $purchasedStayId: Int) {
  checkAskHolder(reservationId: $reservationId, purchasedStayId: $purchasedStayId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CheckAskHolderInjectable extends Apollo.Query<CheckAskHolderQueryResult, CheckAskHolderQueryVariables> {
    override document = CheckAskHolderGql;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
/* eslint-enable */